<template>
  <v-row dense align="center">
    <v-col>Total de la semaine</v-col>
    <v-col v-for="(field, index) in fields" :key="'total' + index">
      <EntryFormInput 
        v-if="subTotal[field.key] >= 0" 
        v-model="subTotal[field.key]"
        :icon="field.icon"
        :type="field.type"
        readonly
      />
    </v-col>
  </v-row>
</template>

<script>
import EntryFormInput from '@/components/Entry/EntryFormInput'
export default {
  name: 'EntryFormRow',
  components: {EntryFormInput},
  props: {
    fields: {type: Array, required: true},
    entries: {type: Array, required: true}
  },
  computed: {
    subTotal () {
      const totalObject = {}

      for (const field of this.fields) {
        if (field.type === 'ca') {
          totalObject[field.key] = this.entries.reduce((base, entry) => ((parseFloat(base) + parseFloat(entry[field.key]))), 0)
        } else if (field.type === 'number') {
          totalObject[field.key] = this.entries.reduce((base, entry) => (base + (entry[field.key] || 0)), 0)
        }
      }

      return totalObject
    },
    entry: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
